import type { GameState } from "@dailywars/core/engine";

import type { CanvasMoveAnimation } from "#/game/animation/types";
import type { AttackRangeFlashIconStyle } from "#/game/attackRangeFlashIcon";

export const TILE_SIZE = 48;

export const HOVER_TILE_STROKE = "rgba(255, 255, 255, 0.88)";
export const TILE_GRID_BORDER_STROKE = "rgba(0, 0, 0, 0.02)";
export const PATH_TILE_FILL = "rgba(255, 208, 60, 0.52)";
export const ATTACKABLE_TILE_FILL = "rgba(255, 80, 80, 0.40)";
export const ATTACKABLE_TILE_STROKE = "#ff2424";
export const ATTACKABLE_TILE_BORDER_WIDTH = 3;
export const ATTACKABLE_TILE_BORDER_INSET = 2;
export const UNMOVED_TILE_FILL = "rgba(64, 140, 255, 0.40)";
export const UNMOVED_TILE_STROKE = "#2f7fff";
export const SELECTED_UNIT_STROKE = "rgba(255, 224, 107, 1)";
export const SELECTED_UNIT_BORDER_WIDTH = 2.5;
export const CAPTURE_BAR_TRACK_FILL = "rgba(60, 60, 60, 1)";

export interface CanvasViewState {
  selectedUnitId: string | null;
  reachableKeys: string[];
  pathKeys: string[];
  previewUnit: {
    unitId: string;
    pos: { x: number; y: number };
    targetPos?: { x: number; y: number };
  } | null;
  previewAnimation: CanvasMoveAnimation | null;
  attackableUnitIds: string[];
  attackableTileKeys: string[];
  attackRangeFlashTileKeys: string[];
  attackRangeFlashStyle: AttackRangeFlashIconStyle;
  unmovedHighlightUnitIds: string[];
  unmovedHighlightFadeStartedAtMs: number | null;
  hoveredTileKey: string | null;
}

export function tileIndex({ x, y, width }: { x: number; y: number; width: number }): number {
  return y * width + x;
}

export function getCanvasSize(state: GameState): { width: number; height: number } {
  return {
    width: state.width * TILE_SIZE,
    height: state.height * TILE_SIZE,
  };
}
